// TODO:    maybe these type of controllers should have their own place.
//          maybe such things like a modal controller would come in handy these days. => this would lead to actions stored within the client which do not have to be prepared by the server. therefor no shadowComponents and server requests would be necessary.
//          the same thing could be applied to error displays, deciders, ...

// @see MARK: GLOBAL_ACTIONS_VIA_CONTROLLERS within frontend-controller/server/globalActions.js for further details.

const utils     = require('../../lib/utils')
const CONSTANTS = require('../../lib/constants')

module.exports = {

    actions: {
        addPopover: {
            type: CONSTANTS.COMPONENT.ACTION.TYPE.LOAD,
            source: {
                container: {
                    componentData: {
                        component: [
                            'base',
                            'popover',
                            'popover'
                        ],
                        config: {
                            clickableOnly: true,
                            autoOpen: true,
                            prepareEmpty: true,
                        },
                        model: {
                            $trigger: null
                        }
                    }
                },
                content: {
                    componentData: {
                        config: {
                            lastMileSelector: '> .container > .popover_content'
                        }
                    },
                    setParentViaActionSourceKey: 'container',
                    target: {
                        element: CONSTANTS.COMPONENT.ACTION.TARGET.ELEMENT.ACTION_SOURCE_KEY,
                        position: CONSTANTS.COMPONENT.ACTION.TARGET.POSITION.HTML,
                        actionSourceKey: 'container'
                    }
                },
            },
            target: {
                element: CONSTANTS.COMPONENT.ACTION.TARGET.ELEMENT.SUB_SELECTOR,
                position: CONSTANTS.COMPONENT.ACTION.TARGET.POSITION.REPLACE,
                selector: ''
            }
        }
    },

    /**
     * returns an action definition replacing the given $trigger with a popover surrounding this trigger.
     * action.source.container refers to the popover itself.
     * action.source.content refers to the content of the popover which has to be extended by the callee.
     *
     * @param $trigger              jquery - trigger element
     * @param triggerSelector       string - subSelector used to find the trigger before the popover has been initialized.
     * @returns action object
     */
    getPopoverAction($trigger, triggerSelector){
        // TODO: error handling?
        if(!$trigger || $trigger.length < 1) return false;
        if(!triggerSelector) return false;

        const action = utils.simpleCopy(this.actions.addPopover)
        action.target.selector = triggerSelector
        action.source.container.componentData.model.triggerHTML = $trigger[0].outerHTML
        return action
    },
}